<template>
  <div class="bb-copy-cell">
  <template v-if="value && isHoveredRow">
      <span
        v-if="!wasCopiedValue"
        class="bb-copy-cell__copy-icon"
        @click="copyToClipboard"
      >
      <img
        :src="require('@/assets/images/icon-copy.png')"
        alt="copy"
      >
    </span>
    <span
      v-else
      class="bb-copy-cell__copied-message"
    >
        Copied
      </span>
  </template>
  </div>
</template>

<script>
import _, {get, set} from 'lodash'
import convertNumber from '@/mixin/convertNumber'
import PopupInfo from "../../PopupInfo/PopupInfo.vue";

export default {
  name: 'CopyCell',
  components: {PopupInfo},
  props: ['row', 'column', 'index', 'hover'],
  mixins: [convertNumber],
  data () {
    return {
      isShowPromptPopup: false,
      popupPosition: {},
      wasCopiedValue: false,
    }
  },
  computed: {
    isHoveredRow() {
      return this.hover === this.row.id
    },
    value: {
      get: function () {
        const isNumber = this.column.type === 'number'
        const fromProp = get(this.row, this.column.prop, '')
        const prefix = get(this.column, 'prefix', '')
        const postfix = get(this.column, 'postfix', '')
        let value = get(this.row, this.column.display, fromProp)
        value = (isNumber && (!this.column.editable || !this.row.openEdit)) ? this.convertNumber(value) : value
        return prefix + value + postfix
      },
      set: function (data) {
        return set(this.row, this.column.prop, data)
      }
    },
  },
  methods: {
    async copyToClipboard() {
      await navigator.clipboard.writeText(this.value);

      this.wasCopiedValue = true;
      setTimeout(() => {
        this.wasCopiedValue = false;
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-copy-cell {
  @include global-font;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  height: 100%;

  &__copy-icon {
    flex: 0 0 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    transform: translateY(1px);

    img {
      max-width: 100%;
    }
  }

  &__copied-message {
    padding: 3px 5px;
    border-radius: 4px;
    background-color: rgba($color-accent, 0.2);
    color: $color-accent;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/CopyCell/CopyCell.vue